export default "__VITE_ASSET__31c6a258__"